// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5131) return "static/chunks/5131-08ac7b54fe11e9a9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"684":"b8fae2366c7cc32f","2608":"f73325c62b1922ef"}[chunkId] + ".js";
};